import React from 'react'
import Faq from '../Components/Footer/Faq/Faq'
import Footer from '../Components/Footer/Footer'
import NavBar from '../Components/NavBar/NavBar'
function FAQ() {
  return (
    <div>
      <NavBar />
      <Faq />
      <Footer />
    </div>
  )
}

export default FAQ
